(function () {
  const nearestPercent = (compareCents, priceCents) => {
    if (!compareCents || compareCents <= priceCents) return 0;
    return Math.round(((compareCents - priceCents) * 100) / compareCents);
  };

  const init = (root) => {
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    if (!form || root.dataset.nervcorReady === 'true') return;
    root.dataset.nervcorReady = 'true';

    let catalog = [];
    try {
      catalog = JSON.parse(root.querySelector('[data-nervcor-catalog]').textContent);
    } catch (error) {
      catalog = [];
    }

    const slides = Array.from(root.querySelectorAll('[data-nervcor-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-nervcor-thumb]'));
    const stage = root.querySelector('[data-nervcor-stage]');
    const showSlide = (index) => {
      const slide = slides[index];
      if (!slide || !stage) return;
      stage.src = slide.dataset.src;
      stage.alt = slide.dataset.alt || '';
      stage.parentElement.classList.toggle('is-plain', slide.dataset.plain === 'true');
      thumbs.forEach((thumb, thumbIndex) => {
        thumb.setAttribute('aria-current', thumbIndex === index ? 'true' : 'false');
      });
    };
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => showSlide(index));
    });

    const variantInput = form.querySelector('input[name="id"]');
    const variantSelect = root.querySelector('[data-nervcor-variant]');
    if (variantSelect && variantInput) {
      variantSelect.addEventListener('change', () => {
        variantInput.value = variantSelect.value;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantSelect.value);
        window.history.replaceState({}, '', url);
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    const onceInput = root.querySelector('[data-nervcor-once]');
    const subInput = root.querySelector('[data-nervcor-sub]');
    const planSelect = root.querySelector('[data-nervcor-selling-plan]');
    const qty = root.querySelector('[data-nervcor-qty]');
    const priceEl = root.querySelector('[data-nervcor-price]');
    const compareEl = root.querySelector('[data-nervcor-compare]');
    const badgeEl = root.querySelector('[data-nervcor-badge]');
    const oncePriceEl = root.querySelector('[data-nervcor-once-price]');
    const subPriceEl = root.querySelector('[data-nervcor-sub-price]');
    const subSaveEl = root.querySelector('[data-nervcor-sub-save]');
    const submitLabel = root.querySelector('[data-nervcor-submit-label]');
    const stickyLabel = root.querySelector('[data-nervcor-sticky-label]');
    const stickyPrice = root.querySelector('[data-nervcor-sticky-price]');
    const plans = root.querySelector('[data-nervcor-plans]');

    const variantData = () => catalog.find((item) => String(item.id) === String(variantInput.value)) || catalog[0];

    const rechargeOwnsPlans = () =>
      !!form.querySelector('.rc-widget, .rc-container, .rc_widget, .rc_widget__option, [data-widget-id]');

    const planFromSelect = () => {
      const data = variantData();
      if (!data || !planSelect) return null;
      return (data.plans || []).find((plan) => String(plan.id) === String(planSelect.value)) || (data.plans && data.plans[0]) || null;
    };

    const selectedPlan = () => {
      if (!subInput || !subInput.checked) return null;
      return planFromSelect();
    };

    const sync = () => {
      const data = variantData();
      if (!data) return;
      const plan = selectedPlan();
      const selling = plan ? plan.price : data.price;
      const formatted = plan ? plan.formatted : data.priceFormatted;
      const percent = nearestPercent(data.compare, selling);

      if (priceEl) priceEl.textContent = formatted;
      if (compareEl) {
        const showCompare = data.compare > selling;
        compareEl.hidden = !showCompare;
        compareEl.textContent = showCompare ? data.compareFormatted : '';
      }
      if (badgeEl) {
        badgeEl.hidden = percent < 1;
        badgeEl.textContent = percent > 0 ? `SAVE ${percent}%` : '';
      }
      if (oncePriceEl) oncePriceEl.textContent = data.priceFormatted;
      if (subPriceEl && data.plans && data.plans.length) {
        const shown = plan || data.plans.find((item) => item.default) || data.plans[0];
        subPriceEl.textContent = shown.formatted;
        if (subSaveEl) {
          const rate =
            shown.price < data.price ? Math.round(((data.price - shown.price) * 100) / data.price) : 0;
          subSaveEl.hidden = rate < 1;
          subSaveEl.textContent = rate > 0 ? `Save ${rate}%` : '';
        }
      }
      if (planSelect && subInput) {
        planSelect.disabled = !subInput.checked;
      }
      root.classList.toggle('is-subscribe', !!(subInput && subInput.checked));
      if (rechargeOwnsPlans() && planSelect) {
        planSelect.removeAttribute('name');
        const onceRc = form.querySelector('.rc_widget__option__input--onetime');
        const subRc = form.querySelector('.rc_widget__option__input--subsave');
        const hiddenPlan = form.querySelector('input[type="hidden"][name="selling_plan"]');
        const dropdown = form.querySelector('.rc-selling-plans__dropdown');
        if (subInput.checked) {
          if (dropdown) dropdown.value = planSelect.value;
          if (subRc) subRc.checked = true;
          if (hiddenPlan) hiddenPlan.value = planSelect.value;
        } else {
          if (onceRc) onceRc.checked = true;
          if (hiddenPlan) hiddenPlan.value = '';
        }
      }
      if (submitLabel) submitLabel.textContent = data.available ? 'Add to cart' : 'Sold out';
      const submitButton = form.querySelector('[name="add"]');
      const stickySubmit = root.querySelector('[data-nervcor-sticky-submit]');
      [submitButton, stickySubmit].forEach((button) => {
        if (!button) return;
        button.disabled = !data.available;
        button.setAttribute('aria-disabled', data.available ? 'false' : 'true');
        const label = button.querySelector('span');
        if (label && button !== submitButton) label.textContent = data.available ? 'Add to cart' : 'Sold out';
      });
      if (stickyLabel) stickyLabel.textContent = plan ? 'Subscribe & save' : 'One-time purchase';
      if (stickyPrice) stickyPrice.textContent = formatted;
      const shownPlan = planFromSelect();
      document.querySelectorAll('[data-nervcor-routine-once]').forEach((el) => {
        el.textContent = data.priceFormatted;
      });
      document.querySelectorAll('[data-nervcor-plan-price]').forEach((el) => {
        if (shownPlan) el.textContent = shownPlan.formatted;
      });
    };

    const setQty = (value) => {
      if (!qty) return;
      const digits = String(value).replace(/[^\d]/g, '');
      const next = Math.max(1, parseInt(digits, 10) || 1);
      qty.value = String(next);
    };
    const qtyWrap = root.querySelector('.nervcor-qty');
    if (qtyWrap) {
      qtyWrap.addEventListener('click', (event) => {
        const button = event.target.closest('[data-nervcor-qty-change]');
        if (!button || !qty) return;
        event.preventDefault();
        setQty(Number(qty.value || 1) + Number(button.dataset.nervcorQtyChange));
      });
    }
    if (qty) {
      qty.addEventListener('input', () => {
        qty.value = qty.value.replace(/[^\d]/g, '');
      });
      qty.addEventListener('change', () => setQty(qty.value));
      qty.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowUp') {
          event.preventDefault();
          setQty(Number(qty.value || 1) + 1);
        }
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          setQty(Number(qty.value || 1) - 1);
        }
      });
    }

    const sticky = root.querySelector('.nervcor-sticky');
    const mainButton = form.querySelector('[name="add"]');
    const mobileSticky = window.matchMedia('(max-width: 749px)');
    let stickyFrame = 0;

    const placeSticky = () => {
      if (!sticky) return;
      const viewport = window.visualViewport;
      const inset = viewport
        ? Math.max(0, Math.round(window.innerHeight - viewport.height - viewport.offsetTop))
        : 0;
      document.documentElement.style.setProperty('--nervcor-sticky-browser-inset', `${inset}px`);
    };

    const updateSticky = () => {
      if (!sticky || !mainButton) return;
      const rect = mainButton.getBoundingClientRect();
      const show = mobileSticky.matches && rect.bottom < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      sticky.toggleAttribute('inert', !show);
      if (show) placeSticky();
    };

    const queueSticky = () => {
      if (stickyFrame) return;
      stickyFrame = window.requestAnimationFrame(() => {
        stickyFrame = 0;
        updateSticky();
      });
    };

    root.addEventListener('change', sync);
    updateSticky();
    placeSticky();
    window.addEventListener('scroll', queueSticky, { passive: true });
    window.addEventListener('resize', queueSticky);
    mobileSticky.addEventListener('change', queueSticky);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', () => {
        placeSticky();
        queueSticky();
      });
      window.visualViewport.addEventListener('scroll', placeSticky);
    }
    window.addEventListener('load', queueSticky);

    let rechargeSeen = rechargeOwnsPlans();
    const observer = new MutationObserver(() => {
      if (rechargeSeen || !rechargeOwnsPlans()) return;
      rechargeSeen = true;
      sync();
    });
    observer.observe(form, { childList: true, subtree: true });
    sync();
  };

  document.querySelectorAll('[data-nervcor]').forEach(init);
})();
